import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import AddEditFeedingBargesModal from './Add_Edit/AddEditFeedingBarges';
import DeleteFeedingBargesModal from './Delete/DeleteFeedingBarges';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { getFeedingBargesList } from '../../../slices/feedingBarges/thunk';

const FeedingBargesList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorFeedingBarges = createSelector(
		state => state.FeedingBarges,
		feedingBarges => ({
			feedingBargesList: feedingBarges.feedingBargesList,
			isLoadingList: feedingBarges.isLoadingList,
			isFeedingBargesSuccess: feedingBarges.isFeedingBargesSuccess,
			error: feedingBarges.error,
			isAdding: feedingBarges.isAdding,
			isAdded: feedingBarges.isAdded,
			isAddError: feedingBarges.isAddError,
			isUpdating: feedingBarges.isUpdating,
			isUpdated: feedingBarges.isUpdated,
			isUpdateError: feedingBarges.isUpdateError,
			isDeleting: feedingBarges.isDeleting,
			isDeleted: feedingBarges.isDeleted,
			isDeleteError: feedingBarges.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.roleListSelect,
	// 	roleListSelect => roleListSelect
	// );

	// const roleListSelect = useSelector(selectRolesList);

	const { feedingBargesList, isLoadingList } = useSelector(
		selectorFeedingBarges
	);

	useEffect(() => {
		dispatch(getFeedingBargesList());
	}, []);

	const [dataFeedingBarges, setDataFeedingBarges] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete FeedingBarges
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	const [modalMaintenance, setModalMaintenance] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = feedingBarges => {
		setDataFeedingBarges(feedingBarges);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = feedingBarges => {
		setDataFeedingBarges(feedingBarges);
		handleToggleModal();
	};

	// Update Data
	const handleMaintenance = feedingBarges => {
		setDataFeedingBarges(feedingBarges);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'feedingBarges',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const feedingBargesData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(feedingBargesData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const feedingBargesData =
														cellProps.row.original;
													handleClickDelete(feedingBargesData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Señal de llamada',
				accessorKey: 'serial_number',
				size: 'auto',
			},
			{
				header: 'N° de Matrícula',
				accessorKey: 'registration_number',
				size: 'auto',
			},
			{
				header: 'Tipo',
				accessorKey: 'feeding_barges_type.name',
				dataType: 'multi-select',
				size: 'auto',
			},
			{
				header: 'Estado',
				accessorKey: 'feeding_barges_status.name',
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					let status = row.original.feeding_barges_status;
					let bgColor = status?.bgcolor;
					let txColor = status?.txcolor;
					return row.original.feeding_barges_status ? (
						<div>
							<span
								className={`badge`}
								style={{ backgroundColor: bgColor, color: txColor }}
							>
								{status ? status.name : '-'}
							</span>
						</div>
					) : (
						'N/A'
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'name',
				size: 'auto',
			},
			{
				header: 'Tipo de Establecimiento',
				accessorKey: 'establishment_type.name',
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					return row?.original?.establishment_type?.name
						? row.original.establishment_type.name
						: '-';
				},
			},
			{
				header: 'Establecimiento',
				accessorKey: 'establishment.name',
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					const establishmentName =
						row?.original?.establishment?.name|| '-';
					const establishmentId = row?.original?.establishment_id;

					return establishmentId && row?.original?.establishment?.name ? (
						<span
							onClick={() =>
								window.open(
									`/establishment/summary/${establishmentId}`,
									'_blank'
								)
							}
							style={{
								cursor: 'pointer',
								color: 'var(--vz-primary)',
								textDecoration: 'none',
								fontWeight: 'bold',
							}}
						>
							<i className='ri-links-line'></i> {establishmentName}
						</span>
					) : (
						<span>{establishmentName}</span>
					);
				},
			},
			{
				header: 'Código SIEP',
				accessorKey: 'establishment.code_siep',
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					return row?.original?.establishment?.code_siep
						? row.original.establishment.code_siep
						: '-';
				},
			},

			{
				header: 'Fecha Asignación',
				accessorKey: 'assignation_date',
				size: 'auto',
				dataType: 'date'
			},
			{
				header: 'Tipo de Propiedad',
				accessorKey: 'property_type',
				dataType: 'multi-select',
				size: 'auto',
				accessorFn: row => row?.property_type?.name ?? '-', // Extrae solo el nombre
				Cell: ({ row }) => {
					let status = row?.original?.property_type;
					let bgColor = status?.bgcolor;
					let txColor = status?.txcolor;
					return row?.original?.property_type ? (
						<div>
							<span
								className={`badge`}
								style={{ backgroundColor: bgColor, color: txColor }}
							>
								{status
									? row.original.property_type.name
									: '-'}
							</span>
						</div>
					) : (
						'-'
					);
				},
			},
			{
				header: 'Descripción',
				accessorKey: 'description',

				size: 'auto',
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataFeedingBarges({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Artefacto Naval
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={feedingBargesList || []}
								isLoadingData={isLoadingList}
								nameFile={'artefacto_naval'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataFeedingBarges({});
											handleToggleModal();
										},
										title: 'Crear Artefacto Naval',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditFeedingBargesModal
				dataFeedingBarges={dataFeedingBarges}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>

			<DeleteFeedingBargesModal
				dataFeedingBarges={dataFeedingBarges}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default FeedingBargesList;
